import { render } from "./HostedImage.vue?vue&type=template&id=21e90264"
import script from "./HostedImage.vue?vue&type=script&lang=js"
export * from "./HostedImage.vue?vue&type=script&lang=js"
script.render = render

export default script